export default "__VITE_ASSET__ITFYZNVl__"